// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as TransactionHistoryApiModel from "../api-model/TransactionHistoryApiModel.bs.js";

function decodeApiModel(json) {
  var data = json.result;
  var decodeTransaction = function (transactions) {
    return List.map((function (e) {
                  return {
                          order_id: e.order_id,
                          date: Timestamp$Catalyst.make(e.date),
                          description: e.description,
                          is_reverted: e.is_reverted,
                          amount: Currency.toCurrency(e.amount),
                          wallet_balance: Currency.toCurrency(e.wallet_balance),
                          payment_mode: e.payment_mode,
                          instamojo_payment_id: e.instamojo_payment_id
                        };
                }), transactions);
  };
  return {
          wallet_balance: Currency.toCurrency(data.wallet_balance),
          last_date_timestamp: Belt_Option.getWithDefault(data.last_date_timestamp, 0.0),
          transactions: decodeTransaction(data.transactions)
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(TransactionHistoryApiModel.t_decode(json), "TransactionHistoryEntityMapper.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
